











































import { Component, Vue } from 'vue-property-decorator';
import { ALL_PROJECTS } from '@/queries/Project';
import ProjectEditButton from '@/components/Project/ProjectEditButton.vue';
import ProjectNewButton from '@/components/Project/ProjectNewButton.vue';
import ProjectShowButton from '@/components/Project/ProjectShowButton.vue';
import ProjectDeleteButton from '@/components/Project/ProjectDeleteButton.vue';
import PermissionService from '@/utils/permission-service';

@Component({
  components: {
    ProjectEditButton,
    ProjectNewButton,
    ProjectShowButton,
    ProjectDeleteButton,
  },
})
export default class ProjectList extends Vue {
  private ALL_PROJECTS = ALL_PROJECTS;
  private PermissionService = PermissionService;
}
